export class SalonServices {
  constructor() {
    this.SalonServices = document.querySelector('.js-salon-services');
    this.cta = this.SalonServices.querySelector('.js-services-cta');
    this.initServices();
  }

  initServices() {
    if (this.SalonServices) {
      const menuButtons = this.SalonServices.querySelectorAll('.js-menu-button');
      const categories = this.SalonServices.querySelectorAll('.js-service-category');

      if (categories.length == 0) return;

      // Select first category and hide all others
      if (menuButtons.length) {
        menuButtons[0].classList.add('SalonServices-menuItem--selected');
      }

      //Check against the first category so that the first one is visible on both mobile and desktop
      const firstCategory = categories[0].dataset.category;
      for (let i = 1; i < categories.length; i++) {
        if (categories[i].dataset.category != firstCategory) {
          categories[i].classList.add('SalonServices-category--hidden');
        }
      }

      if (categories[0].classList.contains('js-service-category-withoutMainCTA')) {
        this.cta.classList.add('js-hidden');
      }

      // map categories to content
      for (const menuButton of menuButtons) {
        menuButton.addEventListener('click', () => this.handleMenuClick(menuButton, menuButtons, categories));
        menuButton.classList.add('SalonServices-menuItem--open');
      }

      for (const category of categories) {
        const reorderedServices = {};
        const services = category.children;
        // Order all services by subsection
        for (const service of services) {
          if (reorderedServices[service.dataset.subsection]) {
            reorderedServices[service.dataset.subsection].services.push(service);
          } else {
            reorderedServices[service.dataset.subsection] = {
              title: service.dataset.subsection,
              services: [service],
            };
          }
        }

        // Group services under the same subsection in the DOM
        for (const key of Object.keys(reorderedServices)) {
          const title = document.createElement('div');
          title.classList.add('SalonServices-serviceSubsectionTitle');
          title.innerText = reorderedServices[key].title;
          category.appendChild(title);

          const container = document.createElement('div');
          const containerExtra = document.createElement('div');
          container.classList.add('SalonServices-serviceSubsection');
          container.classList.add('js-servicesSubsection');
          for (const service of reorderedServices[key].services) {
            if (service.classList.contains('js-service')) {
              container.appendChild(service);
            } else {
              containerExtra.appendChild(service);
            }
          }
          category.appendChild(container);
          category.appendChild(containerExtra);
        }
      }
    }
  }

  handleMenuClick(thisButton, allButtons, allCategories) {
    for (const button of allButtons) {
      if (button === thisButton && window.innerWidth < 768) { //on mobile, add ability to collapse open section on click
        button.classList.toggle('SalonServices-menuItem--selected');
      } else if (button === thisButton) {
        button.classList.add('SalonServices-menuItem--selected');
      } else {
        button.classList.remove('SalonServices-menuItem--selected');
      }
    }

    const buttonCategory = thisButton.dataset.category;
    for (const category of allCategories) {
      if (category.dataset.category === buttonCategory && window.innerWidth < 768) { //on mobile, add ability to collapse open section on click
        category.classList.toggle('SalonServices-category--hidden');
      } else if (category.dataset.category === buttonCategory) {
        category.classList.remove('SalonServices-category--hidden');
        if (category.classList.contains('js-service-category-withoutMainCTA')) {
          this.cta.classList.add('js-hidden');
        } else {
          this.cta.classList.remove('js-hidden');
        }
      } else {
        category.classList.add('SalonServices-category--hidden');
      }
    }
  }
}